import axios from 'axios';
import i18n from '@/i18n';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Card background per product, keyed off the product name (see the Candy Pop spec).
const THEMES = [
  { match: /gush|squirt/i, bg: 'bg-candy-lilac' },
  { match: /choco/i, bg: 'bg-candy-choco' },
  { match: /honey/i, bg: 'bg-candy-yellow' },
  { match: /bliss|female|\bher\b/i, bg: 'bg-candy-pink' },
];
const DEFAULT_THEME = { bg: 'bg-candy-cyan' };

export const productTheme = (product) =>
  THEMES.find((t) => t.match.test(product?.name || '')) || DEFAULT_THEME;

// Category tiles cycle through the packaging colours.
const CATEGORY_BGS = ['bg-candy-lilac', 'bg-candy-cyan', 'bg-candy-pink', 'bg-candy-yellow'];
export const categoryBg = (index) => CATEGORY_BGS[index % CATEGORY_BGS.length];

// "Boner Bears — Male Enhancement Gummies" → { brand: "Boner Bears", type: "Male Enhancement Gummies" }
export const splitProductName = (name = '') => {
  const match = name.match(/^(.+?)\s+[—–-]\s+(.+)$/);
  return match ? { brand: match[1], type: match[2] } : { brand: null, type: name };
};

// Category names come from the database in English; known slugs get a translation
export const categoryName = (category, lang = i18n.language) =>
  category ? i18n.getFixedT(lang)(`categoryNames.${category.slug}`, { defaultValue: category.name }) : '';

export const isSoldOut = (product) => typeof product?.stock === 'number' && product.stock <= 0;

// €19.99 in English, 19,99 € in Italian and Russian
const NUMBER_LOCALES = { en: 'en-IE', ru: 'ru-RU', it: 'it-IT' };
const formatters = {};
export const formatPrice = (value, lang = i18n.language) => {
  const locale = NUMBER_LOCALES[lang] || NUMBER_LOCALES.en;
  formatters[locale] ||= new Intl.NumberFormat(locale, { style: 'currency', currency: 'EUR' });
  return formatters[locale].format(Number(value || 0));
};

const byFeaturedOrder = (a, b) => (a.featured_order ?? 99) - (b.featured_order ?? 99);

// The Bears line (gummies, chocolate, honey): named "...Bears..." or in its
// categories. Falls back to featured products if nothing matches.
const BEARS_CATEGORIES = new Set(['enhancement-gummies', 'honey-chocolate']);

export const isBears = (p) => /\bbears?\b/i.test(p.name || '') || BEARS_CATEGORIES.has(p.category);

// Every Bears product for the homepage carousel, featured ones first
export const pickBears = (products) => {
  const bears = products.filter(isBears);
  const pool = bears.length > 0 ? bears : products.filter((p) => p.is_featured);
  return [...pool].sort((a, b) => {
    if (Boolean(a.is_featured) !== Boolean(b.is_featured)) return a.is_featured ? -1 : 1;
    return byFeaturedOrder(a, b);
  });
};

export const fetchProducts = () => axios.get(`${API}/products`).then((r) => r.data || []);
export const fetchCategories = () => axios.get(`${API}/categories`).then((r) => r.data || []);
